import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
// Misma hoja de estilos que Login y Register: es la misma pantalla de auth, no
// una parecida.
import "./Login.css";
import FondoDeGranos, { FONDO_AUTH_ANCHO, FONDO_AUTH_ANGOSTO, RESPALDO_AUTH, usePantallaAncha } from '../components/business/FondoDeGranos';

export default function ForgotPassword() {
  const pantallaAncha = usePantallaAncha();
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const validar = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      setErrors({ email: "El email es requerido" });
      return false;
    }
    if (!emailRegex.test(email)) {
      setErrors({ email: "Ingresá un email válido" });
      return false;
    }
    setErrors({});
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validar()) return;

    setIsLoading(true);

    try {
      await resetPassword(email);
      setEnviado(true);
    } catch (error) {
      // "No existe ese email" se trata como éxito a propósito: contestar la
      // verdad convierte esta pantalla en un verificador de qué direcciones
      // tienen cuenta en Aturno, que es justo lo que busca quien está probando
      // mails ajenos. El usuario legítimo que se equivocó de dirección no
      // recibe nada y lo vuelve a intentar.
      if (error.code === "auth/user-not-found") {
        setEnviado(true);
      } else if (error.code === "auth/invalid-email") {
        setErrors({ email: "Email inválido" });
      } else if (error.code === "auth/too-many-requests") {
        setErrors({
          general: "Demasiados intentos. Esperá unos minutos antes de volver a probar",
        });
      } else {
        setErrors({
          general: "No pudimos enviar el email. Probá de nuevo en un momento",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  /* El mismo fondo que la landing dos, y el mismo componente. Antes estas tres
     pantallas tenían su propio degradado más tres esferas borroseadas que no
     existían en ningún otro lado de la app, así que pasar de la landing a
     "Ingresar" cambiaba de fondo sin motivo.

     `FondoDeGranos` va adentro de `.auth-container` —que ya es `position:
     relative` y `overflow: hidden`— y la tarjeta queda por encima gracias al
     z-index que ya tenía `.auth-content`. */
  return (
    <div className="auth-container">
      <FondoDeGranos
        posicion={pantallaAncha ? FONDO_AUTH_ANCHO : FONDO_AUTH_ANGOSTO}
        respaldo={RESPALDO_AUTH}
      />

      <div className="auth-content">
        <div className="auth-card">
          <div className="auth-header">
            <Link to="/" className="logo-link">
              <img
                src="/logo-aturno.png"
                alt="Aturno Logo"
                className="auth-logo"
              />
            </Link>
            <h2>Recuperá tu contraseña</h2>
            <p>
              {enviado
                ? "Revisá tu casilla de email"
                : "Te mandamos un link para elegir una contraseña nueva"}
            </p>
          </div>

          {enviado ? (
            <div className="auth-form">
              <div className="error-banner" style={{ background: "#E8F5E9", color: "#1B5E20" }}>
                Si <strong>{email}</strong> tiene una cuenta en Aturno, va a recibir un email con
                el link para cambiar la contraseña. Puede tardar unos minutos, y a veces cae en
                spam.
              </div>

              <Link
                to="/auth/login"
                className="btn-primary auth-submit"
                style={{ textDecoration: "none", textAlign: "center" }}
              >
                Volver a iniciar sesión
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="auth-form">
              {errors.general && <div className="error-banner">{errors.general}</div>}

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (errors.email) setErrors({});
                  }}
                  placeholder="tu@email.com"
                  className={errors.email ? "error" : ""}
                  autoComplete="email"
                  autoFocus
                />
                {errors.email && <span className="error-message">{errors.email}</span>}
              </div>

              <button type="submit" className="btn-primary auth-submit" disabled={isLoading}>
                {isLoading ? (
                  <>
                    <span className="spinner"></span>
                    Enviando...
                  </>
                ) : (
                  "Enviar link de recuperación"
                )}
              </button>
            </form>
          )}

          <div className="auth-footer">
            <p>
              ¿Te acordaste?{" "}
              <Link to="/auth/login" className="register-link">
                Iniciá sesión
              </Link>
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}
